var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mtlk-html"}},[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',[_c('el-empty',{attrs:{"description":"暂无预览"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }